import axios from './_nestAxios'

export const obtenerDocumentosxIdDocumentoPrincipal = (id) => axios.get(`/documento-relacionado/${id}/obtenerxDocPrincipal`)
